import { Controller, Control } from "react-hook-form";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
} from "@mui/material";

import CheckIcon from "@mui/icons-material/Check";

import styles from "./DriverLicenseCategories.module.scss";

interface IDriverLicenseOption {
  id: string;
  name: string;
}

interface Props {
  control: Control<any>;
  name: string;
  options: IDriverLicenseOption[];
  isDisabled?: boolean;
}

export const DriverLicenseField = ({
  control,
  name,
  options,
  isDisabled,
}: Props) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>
        <span>Категории прав:</span>
      </div>

      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <FormGroup row className={styles.group}>
            {options.map((option) => {
              const checked = field.value?.includes(option.id);

              return (
                <FormControlLabel
                  key={option.id}
                  disabled={isDisabled}
                  className={styles.label}
                  control={
                    <Checkbox
                      checked={checked}
                      onChange={(event) => {
                        const newValue = event.target.checked
                          ? [...field.value, option.id]
                          : field.value.filter(
                              (item: string) => item !== option.id,
                            );

                        field.onChange(newValue);
                      }}
                      icon={<span className={styles.customBox} />}
                      checkedIcon={
                        <span
                          className={`${styles.customBox} ${styles.checked}`}
                        >
                          <CheckIcon />
                        </span>
                      }
                    />
                  }
                  label={option.name}
                />
              );
            })}
          </FormGroup>
        )}
      />
    </div>
  );
};